module.exports = __webpack_public_path__ + "media/images/pic/saska/saska_news-011cfb2dc99cedda98442fc43feb99d5.png";